import { render, staticRenderFns } from "./CustomDialog copy.vue?vue&type=template&id=90323c0c&scoped=true"
import script from "./CustomDialog copy.vue?vue&type=script&lang=js"
export * from "./CustomDialog copy.vue?vue&type=script&lang=js"
import style0 from "./CustomDialog copy.vue?vue&type=style&index=0&id=90323c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90323c0c",
  null
  
)

export default component.exports